// extracted by mini-css-extract-plugin
export default {"section":"SMLWatchlistView_section__a7iLK","sectionBody":"SMLWatchlistView_sectionBody__7T0Fr"};